import React from 'react';
import OrdersTable from 'components/Table/Orders';
import { ordersModelTrackingSlider } from 'components/Table/Orders/models';
import { Column } from 'components/Layout/Grid';
import OrderDropdown from 'components/OrderDropdown';

const TrackingSlider: React.FC = () => (
  <>
    <Column className="w-100 max-w-lg-100 flex-1 px-0">
      <OrdersTable
        trackingKey="Grid Pedidos"
        tableSearchClassName=" "
        tabFilter={{ billingDate: { ne: null } }}
        model={ordersModelTrackingSlider}
        pageSize={5}
        showButton={false}
        DropdownTemplate={(data: any) => (
          <OrderDropdown {...data} order={data} />
        )}
        customProps={{ showItems: false, showOrderDownloadButtons: false }}
        showFilter
        showTypeDateFilter
      />
    </Column>
  </>
);

export default TrackingSlider;
